import React, { FC, useCallback } from 'react';
import BEMHelper from 'react-bem-helper';

import { IButtonProps } from './interfaces';

import './styles.scss';

const classes = new BEMHelper({
  name: 'button',
  outputIsString: true,
});

const Button: FC<IButtonProps> = ({
  children,
  color = 'black',
  size = 'small',
  type = 'button',
  onClick,
  disabled,
  className,
  ...props
}) => {
  const handleClickButton = useCallback(
    event => {
      if (onClick) {
        event.preventDefault();
        onClick();
      }
    },
    [onClick]
  );
  return (
    <button
      type={type}
      className={`${className} ${classes('', { [color]: true, [size]: true })}`}
      onClick={handleClickButton}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
